import { TRACE_TOOLS_HOST } from '@/constant/config'

// 农资单位
export const unitOptions = ['kg', 'g', 'L', 'mL', 'm', 'cm', '粒', '支', '株', '颗', '棵', '瓶', '个', '件', '卷', '台', '盒', '捆', '把']

export const packOptions = ['袋', '包', '瓶', '个', '件', '卷', '台', '盒', '支', '株', '颗', '棵', '捆', '把']

// 农资种类
export const agrTypeOptions = {
  'seed': {
    label: '种子(苗)',
    icon: 'seed',
    color: '#1a8e1c',
    findApi: TRACE_TOOLS_HOST + '/seed/find',
    detailApi: TRACE_TOOLS_HOST + '/seed/detail',
    detailKey: 'registration_number'
  },
  'pesticide': {
    label: '农药',
    icon: 'pesticide',
    color: '#f2ddf1',
    findApi: TRACE_TOOLS_HOST + '/pesticide/find',
    detailApi: TRACE_TOOLS_HOST + '/pesticide/detail',
    detailKey: 'registration_number'
  },
  'fertilizer': {
    label: '肥料',
    icon: 'fertilizer',
    color: '#5cb423',
    findApi: TRACE_TOOLS_HOST + '/fertilizer/find',
    detailApi: TRACE_TOOLS_HOST + '/fertilizer/detail',
    detailKey: 'id'
  },
  'feed': {
    label: '饲料',
    icon: 'feed',
    color: '#f6d7ad',
    findApi: TRACE_TOOLS_HOST + '/feed/find',
    detailApi: ''
  },
  'drug': {
    label: '兽药',
    icon: 'drug',
    color: '#f19191',
    findApi: TRACE_TOOLS_HOST + '/veterinaryDrug/find',
    detailApi: ''
  }
}

// 地图相关配置
export const mapCenter = [103.948694, 29.208843]
export const mapZoom = 19
export const AmapApiKey = '193fc0936f71e67a0be3b45abe4199ba'

// 种植相关数据
const PLANT_TYPE_DATE = {
  agri: {
    name: '种植', // 名称
    plantType: '种植', // 种植方式
    pickType: '采收',
    svgIcon: 'harvest'
  },
  animal: {
    name: '养殖',
    plantType: '养殖',
    pickType: '出栏',
    svgIcon: 'fence'
  },
  fishery: {
    name: '水产',
    plantType: '养殖',
    pickType: '捕捞',
    svgIcon: 'fish-net'
  },
  forestry: {
    name: '林木',
    plantType: '种植',
    pickType: '采收',
    svgIcon: 'fence'
  }
}
// 地块类型
const LAND_TYPES = ['大田', '大棚', '果园', '水塘', '山地', '养殖区']
// 地块面积单位
const LAND_AREA_UNITS = [
  {
    name: '亩'
  },
  {
    name: '平方米'
  }
]

// 种植标准
const PLANT_STANDARD = [
  {
    label: '有机',
    value: '有机',
    icon: require('@/assets/images/productManage/youji.png')
  },
  {
    label: '绿色',
    value: '绿色',
    icon: require('@/assets/images/productManage/lvse.png')
  },
  {
    label: '无公害',
    value: '无公害',
    icon: require('@/assets/images/productManage/wugonghai.png')
  },
  {
    label: '普通',
    value: '普通',
    icon: require('@/assets/images/productManage/putong.png')
  }
]
// 种植间距
const PLANT_GAP_UNIT = ['mm', 'cm', 'm', '尺', '丈']
// 农产品等级
const GOODS_LEVEL = [
  {
    text: '一等品',
    value: 1
  },
  {
    text: '二等品',
    value: 2
  },
  {
    text: '三等品',
    value: 3
  },
  {
    text: '四等品',
    value: 4
  },
  {
    text: '五等品',
    value: 5
  }
]

// 采收类型
const PICK_TYPE = [
  {
    text: '直接销售',
    value: '直接销售'
  },
  {
    text: '放入仓库',
    value: '放入仓库'
  },
  {
    text: '赠送',
    value: '赠送'
  },
  {
    text: '死亡',
    value: '死亡'
  },
  {
    text: '扔掉',
    value: '扔掉'
  },
  {
    text: '其他',
    value: '其他'
  }
]
const FARM_WORK_TYPE = ['种植', '施肥', '播种', '育苗', '除草', '灌溉', '用农药', '消毒', '预防免疫', '诊疗']
//  1.1 (种养品种检测报告)，2.农药残留检测报告，3.农产品认证证书 4. 产地环境检测报告
const CERTIFY_TYPE = [
  {
    text: '种养品种检测报告',
    value: 1
  },
  {
    text: '农药残留检测报告',
    value: '农药残留检测报告'
  },
  {
    text: '农产品认证证书',
    value: '农产品认证证书'
  },
  {
    text: '产地环境检测报告',
    value: '产地环境检测报告'
  }
]

const EXPRESS_OPTIONS = [
  {
    label: '顺丰速运',
    value: 'SF'
  },
  {
    label: '百世快递',
    value: 'HTKY'
  },
  {
    label: '中通快递',
    value: 'ZTO'
  },
  {
    label: '申通快递',
    value: 'STO'
  },
  {
    label: '圆通速递',
    value: 'YTO'
  },
  {
    label: '韵达速递',
    value: 'YD'
  },
  {
    label: '邮政快递包裹',
    value: 'YZPY'
  },
  {
    label: 'EMS',
    value: 'EMS'
  },
  {
    label: '天天快递',
    value: 'HHTT'
  },
  {
    label: '京东快递',
    value: 'JD'
  },
  {
    label: '优速快递',
    value: 'UC'
  },
  {
    label: '德邦快递',
    value: 'DBL'
  },
  {
    label: '宅急送',
    value: 'ZJS'
  }
]

export {
  PLANT_TYPE_DATE,
  LAND_TYPES,
  LAND_AREA_UNITS,
  TRACE_TOOLS_HOST,
  PLANT_STANDARD,
  PLANT_GAP_UNIT,
  GOODS_LEVEL,
  PICK_TYPE,
  FARM_WORK_TYPE,
  CERTIFY_TYPE,
  EXPRESS_OPTIONS
}
